import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { map, take } from 'rxjs/operators';

import { DynamicFeatureFlagService } from 'shared/services';

@Injectable({ providedIn: 'root' })
export class DynamicFeatureGuard implements CanActivate {
    // CanActivate has been un-deprecated in v18, no reason to switch to functional guards
    constructor(
        private dynamicFeatureService: DynamicFeatureFlagService,
        private router: Router
    ) {}

    public canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
        return this.dynamicFeatureService.isFeatureEnabled$(route.data.requiredFeature).pipe(
            take(1),
            map((isEnabled) => {
                if (isEnabled) {
                    return true;
                }

                const fallbackRoute = route.data['noFeatureFallbackRoute'] ?? '/';
                return this.router.parseUrl(fallbackRoute);
            })
        );
    }
}
